import { render, staticRenderFns } from "./ShowNotificationModal.vue?vue&type=template&id=215feceb&"
import script from "./ShowNotificationModal.vue?vue&type=script&lang=js&"
export * from "./ShowNotificationModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports